<script context="module" lang="ts">
	import wave from '$lib/img/waves/wave-main.svg';
</script>

<script lang="ts">
	export let pageTitle = 'Null';
	export let pageBreak = false;
</script>

<header>
	<div class="bg-[#F02A25] pb-4">
		<div id="header-content" class="px-8 pt-8">
			<h1 class="text-5xl text-white">
				{pageTitle}
			</h1>
		</div>
	</div>
	<svg viewBox="0 0 1440 114.212" class="w-full">
		<path
			fill="#F02A25"
			fill-opacity="1"
			d="M 0 58.767 L 80 74.767 C 160 90.767 320 122.767 480 112.067 C 640 101.767 800 47.767 960 32.067 C 1120 15.767 1280 37.767 1360 48.067 L 1440 58.767 L 1440 0 L 0 0 L 0 58.767 Z"
		/>
	</svg>
</header>
